import fetchJsonp from 'fetch-jsonp';
import { toQueryString } from '../../utils/UrlUtil';
import { mapProviderInfo } from '../constants/index';

const { baiduKey } = mapProviderInfo.baidu;

/**
 * BaiduGeoconvService.
 *
 * convert data points through this endpoint:
 * `https://api.map.baidu.com/geoconv/v2`
 *
 * supports
 * - GCJ02 to BD09
 * - WGS84 to BD09
 * - BD09 to GCJ02
 */
function BaiduGeoconvService() {}

/**
 *
 * @param {{lat: number; lon: number }[]} points
 * @param {{ model: 1 | 2 | 5 }} options model: 1 = GCJ02 to BD09; 2 = WGS84 to BD09; 5 = BD09 to GCJ02
 */
BaiduGeoconvService.prototype.fetchGenerator = function*(points, options) {
    let model = 1;
    if ([1, 2, 5].includes(options.model)) {
        model = options.model;
    }

    /**
     * @type {{ lat:number; lon: number }[]}
     */
    let finalResponse = [];
    let start = 0;
    let end = 0;

    const convertLimit = 20;
    let pointsLeft = points.length;
    while (pointsLeft > 0) {
        let convertNum = pointsLeft >= convertLimit ? convertLimit : pointsLeft;
        start = end;
        end = start + convertNum;
        pointsLeft -= convertNum;

        let inputPoints = points.slice(start, end);

        const coords = inputPoints.map((item) => `${item.lon},${item.lat}`).join(';');

        const queryParams = toQueryString({
            ak: baiduKey,
            model,
            coords
        });

        const url = `https://api.map.baidu.com/geoconv/v2/${queryParams}`;

        const response = yield fetchJsonp(url);

        /**
         * @typedef {Object} ConvertedResponse
         * @property {number} status
         * @property {Object[]} result
         * @property {number} result[].x longitude
         * @property {number} result[].y latitude
         */

        /**
         * @type {ConvertedResponse}
         */
        const jsonResponse = yield response.json();

        jsonResponse.result.forEach((item) => {
            finalResponse.push({
                lat: item.y,
                lon: item.x
            });
        });
    }
    return finalResponse;
};

export default BaiduGeoconvService;
